import { connect, MapDispatchToProps } from 'react-redux';
import { removeBookmark } from '@wix/da-submit-shared/pkg/redux/actions';
import { Props } from './BookmarkActionsDropdown';

export type StateProps = Pick<Props, never>;
export type DispatchProps = Pick<Props, 'onBookmarkRemove'>;
export type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = (dispatch, { folder }) => ({
  onBookmarkRemove: () => dispatch(removeBookmark(folder)),
});

export default connect(null, mapDispatchToProps);
